<template>
  <card>
    <list
      v-if="$store.state.user.sections['dealers']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="false"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "dealer",
      fields: [
        {
          col: " col-12 col-md-6",
          key: "name",
          label: "Название",
          labelKey: "name",
          type: "field",
          textType: "text",
        },
        {
          col: " col-12 col-md-6",
          key: "phone",
          label: "Контакнтный номер",
          labelKey: "phone",
          type: "field",
          textType: "text",
        },
        {
          col: " col-12 col-md-6",
          key: "tin",
          label: "ИНН",
          labelKey: "inn",
          type: "field",
          textType: "text",
        },
        {
          col: " col-12 col-md-6",
          key: "tax_percent",
          labelKey: "tax_percent",
          label: "Процент НДС",
          type: "field",
          textType: "text",
        },
        {
          col: " col-12 col-md-12",
          key: "user",
          labelKey: "user",
          label: "Отвественный сотрудник",
          type: "select",
          modal: "user",
          selectKey: "phone",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_dealer",
      itemLink: "dealers",
      setLink: "dealers",
      columns: [
        {
          key: "name",
          titleKey: "name",
          title: "Название",
        },
        {
          key: "phone",
          titleKey: "phone",
          title: "Контактный номер",
        },
        {
          key: "tin",
          titleKey: "tin",
          title: "ИНН",
        },
        {
          key: "user",
          titleKey: "employee_main",
          object: "name",
          title: "Отвественный сотрудник",
        },
        {
          key: "shops",
          titleKey: "shops",
          object: "name",
          title: "Торговые точки",
          disableLink: true,
        },
        {
          detail: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
